<template>
	<div class="wai">
		<div class="Box">
			<el-card class="left">
				<div class="money">￥{{ this.InfoList.count_money||"--" }}</div>
				<div class="all">总充值金额</div>
				<div class="left_bts">
					<div class="tex" style="margin-left: 180px">已打款：￥{{ this.InfoList.count_cash_money||"--" }}</div>
				</div>
			</el-card>
			<el-card class="right">
				<div class="money">￥{{ this.InfoList.benefit_money ||"--"}}</div>
				<div class="all">结算单总额（含当日）</div>
				<div class="left_bt">
					<div>未提现（含当日）：￥{{ this.InfoList.no_cash_money ||"--"}}</div>
					<div>提现中：￥{{ this.InfoList.cash_money||"--" }}</div>
				</div>
			</el-card>
		</div>
		<div class="Boxs">
			<el-card class="box-card">
				<el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
					<el-row :gutter="35">
						<el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
							<el-form-item label="提现状态：">
								<el-select v-model="queryParams.state" class="w100" @change="search" @clear="search" clearable placeholder="请选择">
									<el-option label="全部" :value="0"></el-option>
									<el-option label="提现中" :value="1"></el-option>
									<el-option label="打款中" :value="2"></el-option>
									<el-option label="已打款" :value="3"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
							<el-form-item label="提现时间：">
								<el-date-picker
									v-model="queryParams.apply_time"
									type="daterange"
									align="right"
									unlink-panels
									start-placeholder="开始时间"
									end-placeholder="结束时间"
									value-format="yyyy-MM-dd HH:mm:ss"
                  				:default-time="['00:00:00', '23:59:59']"
									@change="headerChange"
								>
								</el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="10" :lg="11" :xl="14" class="mb20">
							<el-button size="medium"  type="primary" @click="search">查询</el-button>
							<el-button size="medium" @click="None">重置</el-button>
						</el-col>
					</el-row>
				</el-form>
				<div class="div_buttom">
					<el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">申请提现</el-button>
<!--					<el-button size="medium" type="primary" icon="el-icon-search" @click="addSearch">打开搜索</el-button>-->
				</div>
				<el-table
					ref="multipleTable"
					:data="tableData"
          size="medium"
					tooltip-effect="dark"
					style="width: 100%; text-align: center; margin-top: 10px"
					@selection-change="handleSelectionChange"
					:header-cell-style="{ textAlign: 'center' }"
					:cell-style="{ textAlign: 'center' }"
					border
          v-loading="loading"
				>
					<el-table-column type="selection" width="55"> </el-table-column>
					<el-table-column label="提现时间" width="185">
						<template slot-scope="scope">{{ scope.row.created_at }}</template>
					</el-table-column>
					<el-table-column label="提现周期" width="150">
						<template slot-scope="scope">{{ scope.row.etime }}</template>
					</el-table-column>
					<el-table-column label="划账日期" width="192">
						<template slot-scope="scope">{{ scope.row.finishtime }}</template>
					</el-table-column>
					<el-table-column label="提现金额" width="180">
						<template slot-scope="scope">{{ scope.row.money }}</template>
					</el-table-column>
					<el-table-column label="扣减金额" width="180">
						<template slot-scope="scope">{{ scope.row.deduction_amount }}</template>
					</el-table-column>
					<el-table-column label="实际金额" width="170">
						<template slot-scope="scope">{{ scope.row.actual_amount }}</template>
					</el-table-column>
					<el-table-column label="类别" width="180">
						<template slot-scope="scope">{{ scope.row.type_text }}</template>
					</el-table-column>
					<el-table-column label="状态" width="180">
						<template slot-scope="scope">{{ scope.row.state_text }}</template>
					</el-table-column>
					<el-table-column label="操作" width="150">
						<template slot-scope="scope">
							<el-button type="text" size="medium" @click="Detils(scope.row)">详情</el-button>
						</template>
					</el-table-column>
				</el-table>
				<!-- 分页组件 -->
				<pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo" :limit.sync="queryParams.pageSize" @pagination="getList" />
				<!-- 提现弹框 -->
				<el-dialog title="提现" :close-on-click-modal="false" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
					<span slot="title" style="margin: auto">
						<div style="font-size: 22px; height: 50px; width: 100%; border-bottom: 1px solid #e8e8e8">提现</div>
					</span>
					<div class="AddDiv">
						<div class="money">您将申请提现金额：¥{{this.InfoList.no_today_cash_money }}</div>
						<div class="Kuai">提交申请后我们我们尽快安排打款</div>
						<div class="btn"><el-button size="medium" type="primary" icon="el-icon-plus" @click="Timoney">马上提现</el-button></div>
						<div class="ext">提现请联系商务同学~</div>
					</div>

					<span slot="footer">
						<div style="font-size: 22px; height: 40px; width: 100%; border-top: 1px solid #e8e8e8">
							<el-button size="medium" style="margin-top: 10px; margin-right: 20px" @click="dialogVisible=false">关闭</el-button>
						</div>
					</span>
				</el-dialog>
				<!-- 详情弹框表格 -->
				<el-dialog title="详情" :close-on-click-modal="false" :visible.sync="dialogVisibleB" width="50%" :before-close="handleClose">
					<!-- <span slot="title" style="margin: auto">
						<div style="font-size: 22px; height: 50px; width: 100%; border-bottom: 1px solid #e8e8e8">提现</div>
					</span> -->
					<div class="btn"><el-button size="medium" type="primary" icon="el-icon-plus" @click="AddDetils">导出</el-button></div>
					<el-table
					ref="multipleTable"
					:data="tableDataDetils"
					tooltip-effect="dark"
					style="width: 100%; text-align: center; margin-top: 10px"
					@selection-change="handleSelectionChange"
					:header-cell-style="{ textAlign: 'center' }"
					:cell-style="{ textAlign: 'center' }"
					border
				>
					<el-table-column label="商户单号" width="185">
						<template slot-scope="scope">{{ scope.row.trade_no }}</template>
					</el-table-column>
					<el-table-column label="充值金额" width="180">
						<template slot-scope="scope">{{ scope.row.money }}</template>
					</el-table-column>
					<el-table-column label="分成比例" width="185">
						<template slot-scope="scope">{{ scope.row.benefit }}</template>
					</el-table-column>
					<el-table-column label="分成金额" width="185">
						<template slot-scope="scope">{{ scope.row.money_benefit }}</template>
					</el-table-column>
					<el-table-column label="支付时间" width="185">
						<template slot-scope="scope">{{ scope.row.finistime }}</template>
					</el-table-column>
				</el-table>

					<span slot="footer">
						<div style="font-size: 22px; height: 40px; width: 100%; border-top: 1px solid #e8e8e8">
							<el-button size="medium" style="margin-top: 10px; margin-right: 20px" @click="dialogVisible=false">关闭</el-button>
						</div>
					</span>
				</el-dialog>
			</el-card>
		</div>
	</div>
</template>
<script>
import { OrderApi } from '@/api/Order/index';
import { Session } from '@/utils/storage';
export default {
	name: 'Order_Money',
	components: {},
	data() {
		return {
			dialogVisible: false,
			dialogVisibleB:false,
			SearchFlag: false,
			queryParams: {
				pageNo: 1,
				pageSize: 10,
				state: '',
				apply_time: [],
			},
			StatesList: [],
			tableData: [],
			//详情数据
			tableDataDetils: [],
			multipleSelection: [],
			InfoList: {},
			total: 0,
			// allMoney:(parseFloat(InfoList.count_money) + parseFloat(InfoList.benefit_money)).toFixed(2),
			allMoney:"",
			DetilsParams:{
				pageNo:1,
				pageSize:10,
			},
			DaoId:"",
      loading:false,
		};
	},
	created() {
		const date = new Date();
		const year = date.getFullYear();
		const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
		const day = ('0' + date.getDate()).slice(-2) - 1;
		const time = '00:00:00';
		const times = '23:59:59';
		const formattedDate = `${year}-${month}-${day} ${time}`;
		const formattedDates = `${year}-${month}-${day} ${times}`;
		// this.queryParams.apply_time = [formattedDate, formattedDates];
	},
	methods: {
		//导出列表
		AddDetils(){
			const urlParams = new URLSearchParams();

      if (this.DaoId) {
        urlParams.append('withdraw_id', this.DaoId);
      }

      let url = new URL(window.location.href);
      let token = url.searchParams.get('token');
      if(token!==null){
        urlParams.append('token', token)
      } else if (Session.get('token')) {
        urlParams.append('token', Session.get('token'))
      }
      // 获取基础 URL
      const baseExportUrl = process.env.VUE_APP_BASE_API + '/admin/withdraw/orders';
      // 拼接 URL 参数
      const fullExportUrl = baseExportUrl + '?' + urlParams.toString();
      window.location.href = fullExportUrl;
		},
		//详情列表
		Detils(row){
			this.DaoId=row.id
			this.dialogVisibleB=true
			let params={...this.DetilsParams,withdraw_id:row.id,export:0}
			const api =OrderApi();
			api
				.getOrderDingdan(params)
				.then((res) => {
					if(res.code==0){
						this.tableDataDetils=res.data.data
					}
				})
				.catch((error) => {
					console.error('Error fetching user data:', error);
					this.loading = false;
				});
			
		},
		
		//申请提现按钮
		Timoney(){
			const api = OrderApi();
			api
				.getOrderadd(this.InfoList.no_cash_money)
				.then((res) => {
					if(res.code==0){
						this.$message({
							message: '申请提现成功',
							type: 'success'
						})
						this.dialogVisible = false;
						this.getList();
					}else{
						this.$message({
							message: res.msg,
							type: 'error'
						})
					}
				})
				.catch((error) => {
					console.error('Error fetching user data:', error);
					this.loading = false;
				});
		},
		None(){
			this.queryParams={
				pageNo: 1,
				pageSize: 10,
				state: '',
				apply_time: []
			}
			this.getList();
		},
		headerChange(e) {
			const date = e[0];
			const dates = e[1];
			const year = date.getFullYear();
			const years = dates.getFullYear();
			const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
			const months = ('0' + (dates.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
			const day = ('0' + date.getDate()).slice(-2) - 1;
			const days = ('0' + dates.getDate()).slice(-2) - 1;
			const time = '00:00:00';
			const times = '23:59:59';
			const formattedDate = `${year}-${month}-${day} ${time}`;
			const formattedDates = `${years}-${months}-${days} ${times}`;
			this.queryParams.apply_time = [formattedDate, formattedDates];
			this.getList();
		},
		addList() {
			this.dialogVisible = true;
		},
		handleClose(done) {
			this.dialogVisible = false;
			this.dialogVisibleB = false;
			this.$refs['ruleForm'].resetFields();
		},
		addNoNe() {},
		search() {
			this.getList();
		},
		addSearch() {
			this.SearchFlag = !this.SearchFlag;
		},
		//提现金额列表
		getInfo() {
			const api = OrderApi();
			api
				.getOrderinfo()
				.then((res) => {
					if (res.code == 0) {
						this.InfoList = res.data;
						// this.allMoney=res.data.count_money+res.data.benefit_money
						this.allMoney=(parseFloat(res.data.count_money) + parseFloat(res.data.benefit_money)).toFixed(2)
					}
				})
				.catch((error) => {
					console.error('Error fetching user data:', error);
					this.loading = false;
				});
		},
		//提现列表
		getList() {
		  this.loading = true;
			const api = OrderApi();
			api
				.getOrderwithdraw(this.queryParams)
				.then((res) => {
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.total = res.data.totalCount;
					}
					this.loading = false;
				})
				.catch((error) => {
					console.error('Error fetching user data:', error);
					this.loading = false;
				});
		},
		handleSelectionChange() {},
		//修改
		handleUpdate() {},
		//删除
		handleDel() {},
	},
	mounted() {
		this.getInfo();
		this.getList();
	},
};
</script>
<style lang="scss" scoped>
.wai {
	// padding: 25px;
}
.Box {
	display: flex;
	justify-content: space-between;
	.left {
		width: 50%;
		height: 138px;
		background-color: #fff;
		.money {
			font-size: 34px;
			font-weight: 5px;
			text-align: center;
		}
		.all {
			color: rgb(153, 153, 153);
			text-align: center;
			margin-top: 10px;
			font-size: 14px;
		}
		.left_bt {
			color: rgba(0, 0, 0, 0.65);
			margin-top: 10px;
			display: flex;
			font-size: 14px;
			justify-content: space-around;
		}
	}
	.right {
		width: 46%;
		height: 138px;
		background-color: #fff;
		.money {
			font-size: 34px;
			font-weight: 5px;
			text-align: center;
		}
		.all {
			color: rgb(153, 153, 153);
			text-align: center;
			margin-top: 10px;
			font-size: 14px;
		}
		.left_bt {
			color: rgba(0, 0, 0, 0.65);
			margin-top: 10px;
			display: flex;
			font-size: 14px;
			justify-content: space-around;
		}
		.left_bts {
			color: rgba(0, 0, 0, 0.65);
			margin-top: 10px;
			font-size: 14px;
			margin-left: 200px;
			.tex {
				margin-left: 100px;
			}
		}
	}
}
.Boxs {
	margin-top: 10px;
}
.dialog-footer {
	width: 100%;
	border-top: 1px solid pink !important;
}
.el-dialog__header {
}
.AddDiv {
	width: 60%;
	margin: 0 auto;
	text-align: center;
	margin-top: -20px;
	.money {
		margin-top: 0px;
	}
	.Kuai {
		margin-top: 16px;
	}
	.btn {
		margin-top: 16px;
	}
	.ext {
		margin-top: 16px;
		color: red;
	}
}
</style>
